import type {
  CreditReference,
  HistoryEntry,
  Loan,
  LpaAccount,
  SubmissionDefaults,
} from '../types/aus'

export const loan: Loan = {
  borrower: 'Jody Sanders',
  loanNumber: '260800068212',
  transactionType: 'Refinance',
  propertyType: 'Detached',
  addressLine: '311 Old Louisville Court',
  cityStateZip: 'Guyton, GA 31312',
}

export const creditReference: CreditReference = {
  provider: 'Advantage Credit, Inc.',
  borrower: 'Jody Sanders',
  referenceNumber: '27019916',
  reportType: 'Merge',
  requestType: 'Reissue',
  bureaus: ['Equifax', 'Experian', 'TransUnion'],
  orderedOn: 'Aug 14, 2026',
}

export const submissionDefaults: SubmissionDefaults = {
  submissionType: 'Preliminary Findings',
  institution: 'MortgagePros, LLC',
  lender: 'Not specified',
}

export const lpaAccount: LpaAccount = {
  lpaId: '121555',
  tpoNumber: '0453128',
  branchCode: 'Not required',
}

export const submissionHistory: HistoryEntry[] = [
  {
    id: 'h-1',
    provider: 'fannie',
    result: 'Approve / Eligible',
    submittedAt: 'Aug 18, 2026 8:42 AM',
    submittedBy: 'Stephen Western',
  },
  {
    id: 'h-2',
    provider: 'freddie',
    result: 'Accept',
    submittedAt: 'Aug 17, 2026 3:14 PM',
    submittedBy: 'Stephen Western',
  },
]
